/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShipmentLimitsLiftgateLongThinException } from './ShipmentLimitsLiftgateLongThinException';
import {
    ShipmentLimitsLiftgateLongThinExceptionFromJSON,
    ShipmentLimitsLiftgateLongThinExceptionFromJSONTyped,
    ShipmentLimitsLiftgateLongThinExceptionToJSON,
    ShipmentLimitsLiftgateLongThinExceptionToJSONTyped,
} from './ShipmentLimitsLiftgateLongThinException';

/**
 * Limits that only apply when a liftgate is requested at pickup or delivery. They are stricter
 * than the general line-item limits because carrier liftgates have a finite reach and weight
 * capacity.
 * 
 * @export
 * @interface ShipmentLimitsLiftgate
 */
export interface ShipmentLimitsLiftgate {
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsLiftgate
     */
    maxDimensionInches: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsLiftgate
     */
    maxWeightPerHandlingUnitPounds: number;
    /**
     * 
     * @type {ShipmentLimitsLiftgateLongThinException}
     * @memberof ShipmentLimitsLiftgate
     */
    longThinException: ShipmentLimitsLiftgateLongThinException;
}

/**
 * Check if a given object implements the ShipmentLimitsLiftgate interface.
 */
export function instanceOfShipmentLimitsLiftgate(value: object): value is ShipmentLimitsLiftgate {
    if (!('maxDimensionInches' in value) || value['maxDimensionInches'] === undefined) return false;
    if (!('maxWeightPerHandlingUnitPounds' in value) || value['maxWeightPerHandlingUnitPounds'] === undefined) return false;
    if (!('longThinException' in value) || value['longThinException'] === undefined) return false;
    return true;
}

export function ShipmentLimitsLiftgateFromJSON(json: any): ShipmentLimitsLiftgate {
    return ShipmentLimitsLiftgateFromJSONTyped(json, false);
}

export function ShipmentLimitsLiftgateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentLimitsLiftgate {
    if (json == null) {
        return json;
    }
    return {
        
        'maxDimensionInches': json['maxDimensionInches'],
        'maxWeightPerHandlingUnitPounds': json['maxWeightPerHandlingUnitPounds'],
        'longThinException': ShipmentLimitsLiftgateLongThinExceptionFromJSON(json['longThinException']),
    };
}

  export function ShipmentLimitsLiftgateToJSON(json: any): ShipmentLimitsLiftgate {
      return ShipmentLimitsLiftgateToJSONTyped(json, false);
  }

  export function ShipmentLimitsLiftgateToJSONTyped(value?: ShipmentLimitsLiftgate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxDimensionInches': value['maxDimensionInches'],
        'maxWeightPerHandlingUnitPounds': value['maxWeightPerHandlingUnitPounds'],
        'longThinException': ShipmentLimitsLiftgateLongThinExceptionToJSON(value['longThinException']),
    };
}

